import { getNodeEnv } from "./getNodeEnv"

export const NODE_ENV = getNodeEnv()

const IS_DEV =
  NODE_ENV === `development` || NODE_ENV === `codespace` || NODE_ENV === `burner`
export default IS_DEV
